import { render } from "./TAICreateView.vue?vue&type=template&id=e9cb4e90"
import script from "./TAICreateView.vue?vue&type=script&lang=js"
export * from "./TAICreateView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__